import axios from '../config/axios';

const API_BASE = '/shipments/missing';

export const shipmentMissingService = {
  // Get all missing shipments
  getAllMissing: (page = 1, perPage = 20, filters = {}) => {
    const params = {
      page,
      per_page: perPage,
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get single missing shipment
  getMissing: (missingId) => {
    return axios.get(`${API_BASE}/${missingId}`);
  },

  // Create missing shipment report
  createMissing: (data) => {
    return axios.post(API_BASE, data);
  },

  // Approve missing shipment
  approveMissing: (missingId) => {
    return axios.post(`${API_BASE}/${missingId}/approve`);
  },

  // Reject missing shipment
  rejectMissing: (missingId, rejectionReason) => {
    return axios.post(`${API_BASE}/${missingId}/reject`, {
      rejection_reason: rejectionReason
    });
  },

  // Delete missing shipment
  deleteMissing: (missingId) => {
    return axios.delete(`${API_BASE}/${missingId}`);
  }
};